import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
    ref: "panel",
    class: "viewer__panel"
};
const _hoisted_3 = { class: "viewer__header" };
const _hoisted_4 = ["aria-label"];
const _hoisted_5 = { class: "viewer__body" };
const _hoisted_6 = { class: "viewer__stage" };
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = ["aria-label"];
const _hoisted_9 = ["aria-label"];
const _hoisted_10 = { class: "viewer__counter" };
const _hoisted_11 = {
    ref: "thumbRail",
    class: "viewer__rail"
};
const _hoisted_12 = ["aria-current", "aria-label", "onClick"];
const _hoisted_13 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createElementVNode("div", {
            class: "viewer",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": _ctx.album.title,
            onClick: _cache[4] || (_cache[4] = _withModifiers(
            //@ts-ignore
            (...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
        }, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("header", _hoisted_3, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "viewer__close",
                        "aria-label": _ctx.closeLabel,
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.close && _ctx.close(...args)))
                    }, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "1.6",
                                "stroke-linecap": "round",
                                "aria-hidden": "true"
                            }, [
                                _createElementVNode("path", { d: "M6 6l12 12M18 6L6 18" })
                            ], -1)
                        ]))], 8, _hoisted_4)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_Transition, {
                            name: "viewer-fade",
                            mode: "out-in"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(), _createElementBlock("img", {
                                    key: _ctx.album.photos[_ctx.currentIndex],
                                    src: _ctx.album.photos[_ctx.currentIndex],
                                    alt: `${_ctx.album.title} ${_ctx.currentIndex + 1}`,
                                    class: "viewer__photo",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.next && _ctx.next(...args)))
                                }, null, 8, _hoisted_7))
                            ]),
                            _: 1
                        }),
                        _createElementVNode("button", {
                            type: "button",
                            class: "viewer__nav viewer__nav--prev",
                            "aria-label": _ctx.prevLabel,
                            onClick: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                (...args) => (_ctx.prev && _ctx.prev(...args)))
                        }, [...(_cache[6] || (_cache[6] = [
                                _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "1.6",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "aria-hidden": "true"
                                }, [
                                    _createElementVNode("polyline", { points: "15 6 9 12 15 18" })
                                ], -1)
                            ]))], 8, _hoisted_8),
                        _createElementVNode("button", {
                            type: "button",
                            class: "viewer__nav viewer__nav--next",
                            "aria-label": _ctx.nextLabel,
                            onClick: _cache[3] || (_cache[3] =
                                //@ts-ignore
                                (...args) => (_ctx.next && _ctx.next(...args)))
                        }, [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "1.6",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "aria-hidden": "true"
                                }, [
                                    _createElementVNode("polyline", { points: "9 6 15 12 9 18" })
                                ], -1)
                            ]))], 8, _hoisted_9),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.currentIndex + 1) + " / " + _toDisplayString(_ctx.album.photos.length), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.album.photos, (src, idx) => {
                            return (_openBlock(), _createElementBlock("button", {
                                key: src,
                                type: "button",
                                class: _normalizeClass(["viewer__thumb", { 'viewer__thumb--active': idx === _ctx.currentIndex }]),
                                "aria-current": idx === _ctx.currentIndex ? 'true' : undefined,
                                "aria-label": `Photo ${idx + 1}`,
                                onClick: ($event) => (_ctx.goTo(idx))
                            }, [
                                _createElementVNode("img", {
                                    src: src,
                                    alt: `${_ctx.album.title} thumbnail ${idx + 1}`,
                                    loading: "lazy"
                                }, null, 8, _hoisted_13)
                            ], 10, _hoisted_12));
                        }), 128))
                    ], 512)
                ])
            ], 512)
        ], 8, _hoisted_1)
    ]));
}
